var lib_core = require("lib-core");

var WindowOpenerStateMachine = require("./windowOpenerStateMachine.js");

var WindowOpenerController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(WindowOpenerController, lib_core.Controller);

module.exports = WindowOpenerController;

WindowOpenerController.prototype.createStateMachine = function () {
    return new WindowOpenerStateMachine(this.root, this.configuration.button_id, this.configuration.url);
};